import React, { useState } from 'react';
import { setAdminSession } from '../../Utils/admincommon';
import axios from 'axios';

function AdminLogin(props) {
    const [loading, setLoading] = useState(false);
    const username = useFormInput('');
    const password = useFormInput('');
    const [error, setError] = useState(null);

    const handleLogin = () => {
        setError(null);
        setLoading(true);
        var data = {
            'username': username.value,
            'password': password.value
        }

        const headers = {
            'Content-Type': 'application/json'
        }
        
        axios.post(global.config.api.url.live + '/adminsessions',data, { headers: headers }, { crossdomain: true }).then(response => {
            setLoading(false);
            if (response.data.data.access_token) {
                setAdminSession(response.data.data.access_token, response.data.data.refresh_token, username.value, response.data.data.session_id, response.data.data.nafn, response.data.data.starf);
                //props.history.push('/admin/stjornbord');
            } else {
                console.log(response.data);
                setError("Error in login");
            }
        }).catch(response => {
            console.log(response.data);
            setLoading(false);
            setError("Innskráning tókst ekki!");
        });

    }

    return (
        <main>
            <div className="innskraningssida">
                <h3 className="login">Fagfólk</h3>
                <h2 className="login">Innskráning</h2>
                <div style={{ marginTop: 10 }}>
                    <input type="text" {...username} placeholder="Kennitala" />
                </div>
                <div style={{ marginTop: 10 }}>
                    <input type="password" {...password} placeholder="Lykilorð" />
                </div>
                {error && <><small style={{ color: 'red' }}>{error}</small><br /></>}<br />
                <div style={{ marginTop: 5 }}><input type="button" className="loginbtn" value={loading ? 'Hleð...' : 'Innskrá'} onClick={handleLogin} disabled={loading} /><br /></div>
                <div className="gleymt"><a href="/">Gleymt lykilorð!</a></div>
                <div className="innskraning_onnur">Innskráning fyrir <a href="/login">Sjúklinga</a></div>
            </div>
        </main>
    );
}

const useFormInput = initialValue => {
    const [value, setValue] = useState(initialValue);
    const handleChange = e => {
        setValue(e.target.value);
    }
    return {
        value,
        onChange: handleChange
    }
}

export default AdminLogin;